export type PlanTitle = ReturnType<typeof planTitle>;

export function planTitle(grade: 1 | 2 | 3 | -1) {
  switch (grade) {
    case 1:
      return 'PERSONAL';
    case 2:
      return 'TEAM';
    case 3:
      return 'TEAM PRO';
    case -1:
      return '맞춤형';
    default:
      throw new Error('존재하지 않는 요금제 등급입니다.');
  }
}
